<template>
    <div>
        <!-- <div class="filterBg">
            <el-form size="mini" :model="searchForm" label-position="right" label-width="120px" inline>
                <el-form-item label="卡号:">
                    <el-input v-model="searchForm.cardNumber" placeholder="请输入卡号" class="filter-item" clearable
                        @keyup.enter.native="handleFilter" @clear="handleFilter" />
                </el-form-item>
                <el-form-item label=" "> </el-form-item>
                <el-form-item label=" ">
                    <div style="float: right">
                        <el-button type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div> -->
        <div class="listTable">
            <div class="margins">
                <span>
                    <el-button class="base-button" size="mini" type="primary" icon="el-icon-plus" @click="addCard">新增</el-button>
                    <!-- <el-button type="primary" @click="manageImport">导入</el-button>
                    <el-button type="primary" @click="downfileTransfer">导出</el-button> -->
                </span>
                <span>
                    <!-- <el-button type="primary" @click="templateDown">模板下载</el-button> -->
                </span>
            </div>
            <YzTable max-height="620px" :hasPage="false" :afterRequest="afterRequest" :columnApi="columns" :listApi="listArray"
                :searchForm="searchForm" :autoLoad="true" ref="YzTable" />
        </div>
    </div>
</template>
  
<script>
import Add from "./add.vue";
export default {
    data() {
        return {
            columns: "json/fence.json?v=2",
            listArray: "/dzwl/queryDzwlList",
            searchForm: {
                page: 1,
                pageSize: 10,
                cardNumber: undefined
            },
        };
    },
    created() {
    },
    mounted() {
        this.$bus.$on("fence-list", () => {
            this.handleFilter();
        });
    },
    beforeDestroy() {
        this.$bus.$off("fence-list");
    },
    methods: {
        afterRequest(res) {
            return {
                result: {
                    items: res.result,
                    total: 0
                }
            }
        },
        handleFilter() {
            this.searchForm.page = 1;
            this.$refs["YzTable"].getList(this.searchForm, true);
        },
        addCard() {
            var ins = this.$dialog.getDialog("添加电子围栏");
            if (ins) {
                return;
            }
            this.$dialog.open({
                id:"添加电子围栏",
                title: "添加电子围栏",
                theme: "feature-dialog",
                shade: false,
                area: {
                    height: "280px",
                    width: "400px",
                },
                // location: {
                //     top: null,
                //     left: null,
                //     bottom: "300px",
                //     right: "20px",
                // },
                content: {
                    type: "vue",
                    subCom: Add
                },
            });
        },
        handleEdit(index, row) {
            console.log(index, row);
        },
    },
};
</script>